import '../../App.scss'
import Fade from 'react-reveal/Fade';
export default function Highlight(content) {
const {link, headline, description, image, source, author} = content.content
    return (
            <a href={link} target="_blank" rel="noreferrer" >
        <div className="Featured">
            <img src={image} alt="featured image" />
            <div className="F-Article">
                <h1>{headline}</h1>
                <p> {author}  |  {source}</p>
                <h2>{description}</h2>
            </div>
        </div>
            </a>
    );
}
